/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddColorForm } from '../models/AddColorForm';
import type { EditColorForm } from '../models/EditColorForm';
import type { InboxIndicationColor } from '../models/InboxIndicationColor';
import type { PatchInboxIndicationColorRequest } from '../models/PatchInboxIndicationColorRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InboxIndicationColorsService {
    /**
     * @returns InboxIndicationColor OK
     * @throws ApiError
     */
    public static apiEditColor({
        creatorId,
        id,
        requestBody,
    }: {
        creatorId: number,
        id: number,
        requestBody: EditColorForm,
    }): CancelablePromise<InboxIndicationColor> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/settings/edit-color',
            query: {
                'creatorId': creatorId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns InboxIndicationColor OK
     * @throws ApiError
     */
    public static apiAddColor({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: AddColorForm,
    }): CancelablePromise<InboxIndicationColor> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/settings/add-color',
            query: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Update the colors of a inbox indication colors
     * @returns InboxIndicationColor Edited inbox indication color
     * @throws ApiError
     */
    public static updateInboxIndicationColor({
        id,
        requestBody,
    }: {
        /**
         * Id of inbox indication colors
         */
        id: number,
        /**
         * Updates only valid and specified fields.
         */
        requestBody: PatchInboxIndicationColorRequest,
    }): CancelablePromise<InboxIndicationColor> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/dashboard/api/v1/settings/colors/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `The user has no access to edit the inbox indication color.`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static apiDeleteColor({
        creatorId,
        id,
    }: {
        creatorId: number,
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/settings/delete-color',
            query: {
                'creatorId': creatorId,
                'id': id,
            },
        });
    }
}
